module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"work_filter":"Work filter","yop":"Year of publication"},"cs":{"work_filter":"Filtr děl","yop":"Rok vydání"}}')
  delete Component.options._Ctor
}
